import { OnInit, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { OccurencesService } from '../../occurences.service';
import { SessionService } from '../../../core/session/session.service';
import { SnackbarService } from '../../../shared/services/snackbar.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material';
import { UtilService } from '../../../shared/utils';
import { ValidatedTokenService } from '@app/shared/services/validated-token/validated-token.service';
import { debounceTime } from 'rxjs/operators';
var OccurenceAddCommentsComponent = /** @class */ (function () {
    function OccurenceAddCommentsComponent(occurenceService, sessionService, _snackbarService, iconRegistry, sanitizer, utils, validatedTokenService) {
        this.occurenceService = occurenceService;
        this.sessionService = sessionService;
        this._snackbarService = _snackbarService;
        this.utils = utils;
        this.validatedTokenService = validatedTokenService;
        this.showLoading = false;
        this.newComment = new EventEmitter();
        this.filesToUpload = new Array();
        iconRegistry.addSvgIcon('atachment', sanitizer.bypassSecurityTrustResourceUrl('assets/img/atachment.svg'));
    }
    OccurenceAddCommentsComponent.prototype.ngOnInit = function () {
        this.validatedComments();
    };
    OccurenceAddCommentsComponent.prototype.onSubmit = function () {
        var _this = this;
        this.showLoading = true;
        var payload = {
            occurrenceId: this.occurrenceForm.get('id').value,
            description: this.commentsOccurrenceForm.get('comments').value,
            userName: this.sessionService.getAuthUser().name
        };
        var formData = this.utils.convertPayloadFileToFormData(payload, 'occurrenceComment', this.filesToUpload);
        var msg = '';
        this.occurenceService.addCommentsOccurrence(formData, payload.occurrenceId)
            .subscribe(function (event) {
            msg = 'Seu comentário foi enviado com sucesso!';
            _this.clearComment();
            _this.afterSaveComment(payload.occurrenceId);
            _this.showLoading = false;
            _this._snackbarService.showSnackbar(msg, 'OK');
        }, function (err) {
            msg = "Coment\u00E1rio n\u00E3o enviado!\n        Por favor, tente novamente. Caso o problema persista, contate o seu canal de atendimento.";
            _this.showLoading = false;
            _this._snackbarService.showSnackbar(msg, 'OK');
        });
    };
    OccurenceAddCommentsComponent.prototype.afterSaveComment = function (occurrenceId) {
        this.newComment.emit(true);
        this.filesToUpload = [];
    };
    OccurenceAddCommentsComponent.prototype.validatedComments = function () {
        var _this = this;
        var comments = this.commentsOccurrenceForm.get('comments');
        comments.valueChanges
            .pipe(debounceTime(100))
            .subscribe(function (comment) { return comments.setValue(_this.validatedTokenService.DOMParser(comment)); });
    };
    OccurenceAddCommentsComponent.prototype.clearComment = function () {
        this.commentsOccurrenceForm.get('comments').setValue('');
    };
    OccurenceAddCommentsComponent.prototype.handleFileInput = function (event) {
        var _this = this;
        this.utils.validateFileToUpload(event, this.filesToUpload);
        if (this.filesToUpload.length) {
            this.filesToUpload.forEach(function (file) {
                file.textSize = _this.utils.getSizeFileText(file);
            });
        }
    };
    OccurenceAddCommentsComponent.prototype.removeAtachment = function (index) {
        this.filesToUpload.splice(index, 1);
    };
    return OccurenceAddCommentsComponent;
}());
export { OccurenceAddCommentsComponent };
